// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2DTae","info":"UpdateTermsInfo_info__2Nczf"};